import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { UserProfile } from "@/hooks/useUserProfile";

interface UserAvatarProps {
  profile: UserProfile;
}

export const UserAvatar = ({ profile }: UserAvatarProps) => {
  return (
    <Avatar className="h-16 w-16">
      <AvatarImage src={profile.avatar_url || undefined} alt={profile.full_name || "User"} />
      <AvatarFallback>{profile.full_name?.[0] || "U"}</AvatarFallback>
    </Avatar>
  );
};